import { render, staticRenderFns } from "./recommendCourses.vue?vue&type=template&id=f211f7e6"
import script from "./recommendCourses.vue?vue&type=script&lang=js"
export * from "./recommendCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports